{
  "venueEdit": {
    "insertFailure": "Falha ao criar o local",
    "editFailure": "Falha ao editar o local",
    "deleteFailure": "Falha ao excluir o local",
    "creationSuccess": "Local criado com sucesso",
    "editSuccess": "O local foi alterado com sucesso",
    "deleteSuccess": "Local excluído com sucesso",
    "topLevel": "Nível superior"
  },
  "resetZoom": "Redefinir zoom",
  "shareOrExport": {
    "title": "Programação de compartilhamento/exportação",
    "shareLinkOptionTitle": "Compartilhar link",
    "shareLinkOptionDescription": "Compartilhe a programação selecionada por meio de um link somente para leitura (expiração de 7 dias)",
    "exportOptionTitle": "Cronograma de exportação",
    "exportOptionDescription": "Exportar agenda selecionada",
    "shareLinkLabel": "Link",
    "exportStarted": "A exportação foi iniciada",
    "pickOption": "Selecione uma opção"
  },
  "eventBlocksImport": "A importação foi concluída com êxito",
  "shareSchedule": "O link de agendamento compartilhado foi copiado para sua área de transferência",
  "visitSchedule": "Agenda de visitas"
}